<template>
  <div v-if="reportStatus">
    <q-btn
      v-if="reportStatus.done"
      flat
      dense
      round
      :size="size"
      @mouseover="showBuildingMenu = true"
    >
      <q-icon
        class="col-auto"
        :name="dataFreshnessDisplayData.icon"
        :color="dataFreshnessDisplayData.color"
        :size="size"
      />
      <q-menu
        v-model="showBuildingMenu"
        :offset="[0,10]"
        @mouseleave="showBuildingMenu = false"
      >
        <q-list
          separator
          style="min-width: 200px;"
        >
          <q-item>
            <q-item-section>
              <div class="text-bold">
                Data Freshness
              </div>
              <div class="row items-center q-gutter-sm">
                <q-icon
                  class="col-auto"
                  :name="dataFreshnessDisplayData.icon"
                  :color="dataFreshnessDisplayData.color"
                  size="md"
                />
                <div class="col">
                  {{ dataFreshnessDisplayData.title }}
                </div>
                <q-tooltip>
                  {{ dataFreshnessDisplayData.tooltip }}
                </q-tooltip>
              </div>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <div class="text-bold">
                Last Computed
              </div>
              <div>
                {{ reportStatus.lastComputedAt && reportStatus.lastComputedAt.smartRelativeTime() }}
              </div>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <div class="text-bold">
                Build Time
              </div>
              <div>
                {{ reportStatus.buildTime({ compact: false, duration: true }) }}
              </div>
            </q-item-section>
          </q-item>
        </q-list>
      </q-menu>
    </q-btn>
    <q-btn
      v-else
      dense
      :size="size"
      flat
      @mouseover="showBuildingMenu = true"
    >
      <q-spinner-clock
        v-if="reportStatus.waiting"
        size="sm"
        class="q-mr-sm"
      />
      <q-spinner-grid
        v-if="reportStatus.building"
        size="sm"
        class="q-mr-sm"
      />
      <template v-if="!iconOnly">
        {{ $_.startCase(reportStatus.buildStatus) }}...
      </template>
      <q-menu
        v-model="showBuildingMenu"
        :offset="[0,10]"
        @mouseleave="showBuildingMenu = false"
      >
        <q-list separator>
          <q-item v-if="reportStatus.overallPercentComplete !== null">
            <q-item-section>
              <div class="text-bold">
                Overall Progress
              </div>
              <q-linear-progress :value="reportStatus.overallPercentComplete / 100" />
              <div>Report will be ready in {{ reportStatus.estimatedTimeRemaining() }}</div>
            </q-item-section>
          </q-item>
          <q-item v-if="reportStatus.waitingPercentComplete !== null">
            <q-item-section>
              <div class="text-bold">
                Wait Time
              </div>
              <q-linear-progress :value="reportStatus.waitingPercentComplete / 100" />
              <div v-if="reportStatus.queuePosition === 0">
                Done
              </div><div v-else>
                Estimate {{ reportStatus.estimatedTimeUntilStart() }} until build starts (position {{ reportStatus.queuePosition }} in line)
              </div>
            </q-item-section>
          </q-item>
          <q-item v-if="!reportStatus.done && !reportStatus.error">
            <q-item-section>
              <div class="text-bold">
                Building Time
              </div>
              <q-linear-progress :value="reportStatus.buildPercentComplete / 100" />
              <div>{{ reportStatus.estimatedBuildTimeRemaining() }} of build time remaining</div>
            </q-item-section>
          </q-item>
        </q-list>
      </q-menu>
    </q-btn>
  </div>
</template>

<script>
import ReportStatus, { DATA_FRESHNESS } from 'src/models/report/ReportStatus'

const FRESHNESS_DISPLAY_DATA = {
  [DATA_FRESHNESS.NO_DATA]: {
    title: 'No Data',
    icon: 'warning',
    color: 'negative'
  },
  [DATA_FRESHNESS.FINAL]: {
    title: 'Final',
    tooltip: 'This data is final and not expected to change',
    icon: 'check_circle_outline',
    color: 'positive'
  },
  [DATA_FRESHNESS.PARTIAL]: {
    title: 'Partial Period',
    tooltip: 'The period for this data is not finalized. Explect these values to change.',
    icon: 'done',
    color: 'warning'
  },
  [DATA_FRESHNESS.OUTDATED]: {
    title: 'Outdated',
    tooltip: 'The data has changed and is now outdated. Force recompute to get latest figures.',
    icon: 'warning',
    color: 'warning'
  },
  [DATA_FRESHNESS.MIXED]: {
    title: 'Mixed',
    tooltip: 'The data for this report is mixed. Please see each element for details or force recompute for latest.',
    icon: 'category',
    color: 'warning'
  },
  [DATA_FRESHNESS.DIRTY]: {
    title: 'Dirty',
    tooltip: 'The data for this report is dirty. Please rebuild for latest.',
    icon: 'warning',
    color: 'warning'
  }
}

export default {
  name: 'ReportStatus',
  props: {
    reportStatus: {
      type: ReportStatus,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showBuildingMenu: false
    }
  },
  computed: {
    dataFreshnessDisplayData () {
      return FRESHNESS_DISPLAY_DATA[this.reportStatus.dataFreshness]
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
